import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';

// La renderiza components/ErrorBoundary cuando un componente lanza una excepcion
// durante el render. Sin ese boundary, React 16 desmonta todo el arbol y el
// usuario queda viendo una pantalla en blanco sin ninguna pista.
class Page500 extends Component {
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <span className="clearfix">
                <h1 className="float-left display-3 mr-4">500</h1>
                <h4 className="pt-3">Se produjo un error</h4>
                <p className="text-muted float-left">
                  No pudimos mostrar esta pantalla. Volvé a intentar; si el problema
                  persiste, avisá al área de sistemas.
                </p>
              </span>
              {/* Recarga completa a proposito: el arbol de React quedo en un estado
                  invalido y volver a montar es lo unico que lo recupera. */}
              <Button color="info" onClick={() => window.location.reload()}>
                Reintentar
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Page500;



// WEBPACK FOOTER //
// ./src/views/Pages/Page500/Page500.js